import { useMutation } from 'react-apollo';

import { accountUpdate } from '../../../graphql/mutations/account';

/**
 * Persists the name typed on the checkout form onto the account, so that orders
 * can be identified by the pro. Consumer accounts that never set up a name are
 * stored as "Me", and events shipping to a single address never ask for a
 * shipping address, which is the only other place the web captures a name.
 *
 * Accounts that already have a name of their own are left untouched. Storing
 * the name is best effort, so failures are swallowed and never block a payment.
 *
 * @param {Object} opts The options.
 * @param {Object} opts.account The account checking out.
 * @returns {{saveCheckoutAccountName: Function}}
 */
const useCheckoutAccountName = ({ account }) => {
  const [onAccountUpdate] = useMutation(accountUpdate);

  const saveCheckoutAccountName = async name => {
    const checkoutName = (name ?? '').trim();
    const accountName = (account?.name ?? '').trim();

    if (
      !account?.id ||
      !checkoutName ||
      checkoutName.toLowerCase() === 'me' ||
      (!!accountName && accountName.toLowerCase() !== 'me')
    ) {
      return;
    }

    try {
      await onAccountUpdate({
        variables: {
          input: {
            id: account.id,
            name: checkoutName,
          },
        },
      });
    } catch {
      // Best effort only.
    }
  };

  return {
    saveCheckoutAccountName,
  };
};

export default useCheckoutAccountName;
